/**
 * Status of Trade Request.
 * tag: 750
 * @readonly
 * @enum {number} (int)
 */
export enum TradeRequestStatus {
  /** Accepted */
  Accepted = 0,
  /** Completed */
  Completed = 1,
  /** Rejected */
  Rejected = 2,
}
